import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";

@Component({
  selector: 'app-inputrenderer',
  templateUrl: './inputrenderer.component.html',
  styleUrls: ['./inputrenderer.component.css']
})
export class InputrendererComponent implements ICellRendererAngularComp  {

  public params: any;
  reportedHours:any;
  reportedMins:any;
  hoursArray = new Array();
  
      agInit(params: any): void {
          this.params = params;
          for(let i=0; i<161; i++){
            this.hoursArray.push(i);
          }
          if(this.params.data.reported_hours != null){
            this.reportedHours = this.params.data.reported_hours.toString().split('.')[0];
            this.reportedMins = this.params.data.reported_hours.toString().split('.')[1];
            if(this.reportedMins == undefined){
                this.reportedMins = 0;
            }
          }
      }
  
      refresh(): boolean {
          return false;
      }
      changeValue(){
          this.params.data.reported_hours =parseFloat(this.reportedHours+'.'+this.reportedMins).toFixed(2);
      }

}



// WEBPACK FOOTER //
// ./src/app/inputrenderer/inputrenderer.component.ts